import React, { FC } from 'react'
import { Loader, LoaderChild } from './styled'

interface LoaderProps {
	color?: string
	size?: number
	position?: string
}

export const LoaderSberComponent: FC<LoaderProps> = ({
	color = 'green',
	size = 20,
	position = '',
}) => {
	return (
		<Loader size={size} position={position}>
			<LoaderChild color={color} size={size} />
			<LoaderChild color={color} size={size} />
			<LoaderChild color={color} size={size} />
			<LoaderChild color={color} size={size} />
		</Loader>
	)
}
